var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"user-icon",class:typeof _vm.status === 'number' ? '_'+_vm.status : _vm.status},_vm.$listeners),[_c('img',{attrs:{"src":_vm.url,"alt":"User icon"},on:{"error":function($event){_vm.iconError = true}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }